webpackJsonp([4],Array(18).concat([
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Proposal__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Proposal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Proposal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_404__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_404__);



var dashboard = function dashboard() {
	return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 178));
};
var builder = function builder() {
	return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 176));
};
var companies = function companies() {
	return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 177));
};



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	mode: 'history',
	routes: [{
		path: '/',
		name: 'Dashboard',
		component: dashboard
	}, {
		path: '/builder',
		name: 'Builder',
		component: builder
		//	beforeEnter: guardRoute

	}, {
		path: '/companies',
		name: 'Companies',
		component: companies
	}, {
		path: '/proposal',
		name: 'Proposal',
		component: __WEBPACK_IMPORTED_MODULE_2__pages_Proposal___default.a
		//	beforeEnter: guardRoute

	}, {
		path: '/*',
		component: __WEBPACK_IMPORTED_MODULE_3__pages_404___default.a
	}]
});

function guardRoute(to, from, next) {
	// work-around to get to the Vuex store (as of Vue 2.0)
	var auth = router.app.$options.store.state.auth;

	if (!auth.isLoggedIn) {
		next({
			path: '/',
			query: {
				redirect: to.fullPath
			}
		});
	} else {
		next();
	}
}

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(144)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(171),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 39 */,
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = (EventBus);

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(132)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(69),
  /* template */
  __webpack_require__(158),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_dashboard__ = __webpack_require__(88);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
	modules: {
		dashboard: __WEBPACK_IMPORTED_MODULE_2__modules_dashboard__["a" /* default */]
	}
}));

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(136)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(81),
  /* template */
  __webpack_require__(163),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-420d19b1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return func; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eventBus__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(17);







var func = {
	data: function data() {
		return {
			typingTimer: null,
			savingAnimationTimer: null,
			doneTypingInterval: 2000,
			milestoneList: [],
			proposalData: {}
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['milestones', 'proposal'])),
	methods: {
		keyPressManager: function keyPressManager(event) {
			var keyPressed = event.key;
			var shiftKeyPressed = event.shiftKey;

			switch (keyPressed) {
				case 'Enter':
					event.preventDefault();
					if (shiftKeyPressed) {
						this.addPhase();
					} else if (event.altKey) {
						var input = event.target;
						input.value += '\n';
						this.autosize(input);
					} else {
						this.addSibling();
					}

					break;
				case 'ArrowLeft':
					shiftKeyPressed && this.shiftOut();
					break;
				case 'ArrowRight':
					shiftKeyPressed && this.shiftIn();
					break;
				case 'ArrowDown':
					shiftKeyPressed && this.switchWithLowerSibling();
					break;
				case 'ArrowUp':
					shiftKeyPressed && this.switchWithUpperSibling();
					break;
			}
		},
		keyPressManagerChildren: function keyPressManagerChildren(event) {
			var keyPressed = event.key;
			var shiftKeyPressed = event.shiftKey;
			switch (keyPressed) {
				case 'Enter':
					event.preventDefault();
					if (event.altKey) {
						var input = event.target;
						input.value += '\n';
						this.autosize(input);
					} else {
						this.addSiblingChildren();
					}
					break;
				case 'ArrowLeft':
					shiftKeyPressed && this.shiftOut();
					break;
				case 'ArrowRight':
					shiftKeyPressed && this.shiftIn();
					break;
				case 'ArrowDown':
					shiftKeyPressed && this.switchWithLowerSibling();
					break;
				case 'ArrowUp':
					shiftKeyPressed && this.switchWithUpperSibling();
					break;
			}
		},
		addSiblingChildren: function addSiblingChildren() {
			this.$store.dispatch('addSibling', {
				id: 0,
				values: {
					name: "",
					time: "",
					price: "",
					toggleButtonIsChecked: false,
					parentID: this.id
				},
				children: []
			});
		},
		addPhase: function addPhase() {
			this.$store.dispatch('addPhase', {
				id: 0,
				values: {
					name: "Phase ",
					time: "",
					price: "",
					info: "",
					parentID: 0,
					"Price-Long": "",
					"Time-Long": "",
					"Taxes-19": true,
					"Taxes-19-Long": "",
					"Taxes-7-Long": "",
					"Taxes-5-Long": "",
					"Taxes-16-Long": ""
				},
				children: []
			});
			this.saveMilestones();
		},
		addChild: function addChild() {
			this.$store.dispatch('addChild', {
				id: 0,
				values: {
					name: "",
					time: "",
					price: "",
					pageBreak: false,
					bulletPoint: true,
					parentID: this.id
				},
				children: []
			});
			this.saveMilestones();
		},
		addSibling: function addSibling() {
			this.$store.dispatch('addSibling', {
				id: 0,
				values: {
					name: "",
					time: "",
					price: "",
					info: "",
					pageBreak: false,
					bulletPoint: true,
					parentID: this.id,
					"Price-Long": "",
					"Time-Long": "",
					"Taxes-19": true,
					"Taxes-19-Long": "",
					"Taxes-7-Long": "",
					"Taxes-5-Long": "",
					"Taxes-16-Long": ""
				},
				children: []
			});
			this.saveMilestones();

			var newMilestone = this.milestones.items[this.milestones.items.length - 1];
			__WEBPACK_IMPORTED_MODULE_3__eventBus__["a" /* default */].$emit('open-phase-info', newMilestone.id, this.proposal.id, '');
		},
		removeTile: function removeTile() {
			__WEBPACK_IMPORTED_MODULE_3__eventBus__["a" /* default */].$emit('close-phase-info', this.id, this.proposal.id, '');

			var self = $(this.$el);
			var children = self.find("li").length;

			var milestones = this.milestones.items;
			if (children > 20) {
				__WEBPACK_IMPORTED_MODULE_3__eventBus__["a" /* default */].$emit('openModal', this.id);
			} else {
				this.$store.dispatch('removeTile', this.id);
				this.saveMilestones();
			}
		},
		switchWithLowerSibling: function switchWithLowerSibling() {
			this.$store.dispatch('switchWithLowerSibling', this.id);
			this.saveMilestones();
		},
		switchWithUpperSibling: function switchWithUpperSibling() {
			this.$store.dispatch('switchWithUpperSibling', this.id);
			this.saveMilestones();
		},
		shiftOut: function shiftOut() {
			this.$store.dispatch('shiftOut', this.id);
			this.saveMilestones();
		},
		shiftIn: function shiftIn() {
			this.$store.dispatch('shiftIn', this.id);
			this.saveMilestones();
		},
		updateTime: function updateTime() {
			this.$store.dispatch('updateTime');
			this.saveMilestones();
		},
		updatePrice: function updatePrice() {
			this.$store.dispatch('updatePrice');
			this.saveMilestones();
		},
		replaceAll: function replaceAll(str, find, replace) {
			return str.replace(new RegExp(find, 'g'), replace);
		},
		hasClass: function hasClass(target, className) {
			return new RegExp('(\\s|^)' + className + '(\\s|$)').test(target.className);
		},
		getDate: function getDate() {
			var today = new Date();
			var dd = today.getDate();
			var mm = today.getMonth() + 1;
			var yyyy = today.getFullYear();

			if (dd < 10) {
				dd = '0' + dd;
			}

			if (mm < 10) {
				mm = '0' + mm;
			}

			today = dd + '.' + mm + '.' + yyyy;
			return today;
		},
		isPercentageBased: function isPercentageBased(value) {
			return value[value.length - 1] === '%';
		},
		save: function save() {
			var proposalData = {};

			proposalData.projectInfo = this.projectInfo;
			proposalData.confirmation = this.confirmation;
			proposalData.milestones = this.milestones;

			localStorage.setItem('PROPOSAL_DATA', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(proposalData));

			this.saveMilestones();
			this.startSavingAnimation();

			clearTimeout(this.typingTimer);
			this.typingTimer = setTimeout(this.stopSavingAnimation, this.doneTypingInterval);
		},
		saveMilestones: function saveMilestones() {
			var data = {};
			data.milestones = this.milestones;
			data.id = this.proposal.id;
			this.$store.dispatch('updateMilestones', data);
		},
		stopSavingAnimation: function stopSavingAnimation() {
			setTimeout(function () {
				__WEBPACK_IMPORTED_MODULE_3__eventBus__["a" /* default */].$emit('stopSaving');
			}, 3800);
		},
		startSavingAnimation: function startSavingAnimation() {
			__WEBPACK_IMPORTED_MODULE_3__eventBus__["a" /* default */].$emit('startSaving');
		},
		autosize: function autosize(el) {
			el.style.height = 'auto';
			el.style.height = el.scrollHeight + 'px';
		}
	}
};

/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(142)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(76),
  /* template */
  __webpack_require__(169),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-af09e22c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'CompanyAddress',
	props: {
		company: {
			type: Object,
			default: function _default() {
				return {
					Name: '',
					Address: { Street: '', House: '', PLZ: '', City: '' },
					Phone: '',
					Fax: '',
					Email: '',
					Site: '',
					Owners: '',
					Registration: '',
					TaxNumber: '',
					BankDetails: { BankName: '', IBAN: '', BIC: '' }
				};
			}
		}
	}
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Page_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Page_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Page_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CompanyAddress_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CompanyAddress_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CompanyAddress_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CoverPage',
    components: {
        Page: __WEBPACK_IMPORTED_MODULE_0__Page_vue___default.a,
        CompanyAddress: __WEBPACK_IMPORTED_MODULE_1__CompanyAddress_vue___default.a
    },
    props: {
        company: {
            type: Object,
            default: function _default() {
                return null;
            }
        },
        logoPosition: {
            type: String,
            default: 'left'
        },
        projectConfirmation: {
            type: String,
            default: function _default() {
                return null;
            }
        },
        projectDate: {
            type: String,
            default: function _default() {
                return "";
            }
        },
        projectType: {
            type: String,
            default: function _default() {
                return "";
            }
        },
        projectNumber: {
            type: String,
            default: function _default() {
                return "";
            }
        }
    },

    data: function data() {
        return {};
    },
    created: function created() {},

    watch: {
        projectConfirmation: function projectConfirmation(val) {
            this.$refs.projectConfirmation.innerHTML = val;
        }
    },
    computed: {
        logoSrc: function logoSrc() {
            if (!this.company || this.company.isMain) return __webpack_require__(22);
            var name = this.company.LogoName || (this.company.InternalName ? this.company.InternalName.toLowerCase() + '.svg' : '');
            return name ? '/static/' + name : __webpack_require__(22);
        }
    },
    methods: {},
    mounted: function mounted() {
        this.$refs.projectConfirmation.innerHTML = this.projectConfirmation;
    }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Page_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Page_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Page_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CompanyAddress_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CompanyAddress_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CompanyAddress_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'CoverPage',
	components: {
		Page: __WEBPACK_IMPORTED_MODULE_0__Page_vue___default.a,
		CompanyAddress: __WEBPACK_IMPORTED_MODULE_1__CompanyAddress_vue___default.a
	},
	props: {
		projectInfo: {
			type: Object,
			default: function _default() {
				return null;
			}
		},
		company: {
			type: Object,
			default: function _default() {
				return null;
			}
		},
		logoPosition: {
			type: String,
			default: 'left'
		}
	},
	data: function data() {
		return {
			pages: []
		};
	},
	created: function created() {},

	watch: {
		projectInfo: function projectInfo(val) {
			this.projectInfo['Project-Description'] = val['Project-Description'];
			this.splitContent();
		}
	},
	computed: {
		logoSrc: function logoSrc() {
			if (!this.company || this.company.isMain) return __webpack_require__(22);
			var name = this.company.LogoName || (this.company.InternalName ? this.company.InternalName.toLowerCase() + '.svg' : '');
			return name ? '/static/' + name : __webpack_require__(22);
		}
	},
	methods: {
		lines: function lines(string) {
			console.log(string);
			return string.split('\n');
		},
		splitContent: function splitContent() {
			this.pages = [];
			var content = this.projectInfo['Project-Description'].split('/Br');

			for (var i = 0; i < content.length; i++) {
				var obj = {};
				obj.content = content[i];
				this.pages.push(obj);
			}
		}
	},
	mounted: function mounted() {
		if (this.projectInfo['Project-Description'] != undefined) {
			this.splitContent();
		}
	}
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'FirstLayer',
	props: {
		itemValues: {
			type: Object,
			default: function _default() {
				return {
					name: "",
					time: "",
					price: "",
					timeInDays: false
				};
			}
		}

	},
	components: {},
	data: function data() {
		return {};
	},
	created: function created() {},


	watch: {},
	computed: {},
	methods: {},

	mounted: function mounted() {}
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Page_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Page_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Page_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PriceTable_vue__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PriceTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PriceTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Phase_vue__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Phase_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Phase_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FirstLayer_vue__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FirstLayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__FirstLayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SecondLayer_vue__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SecondLayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SecondLayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ThirdLayer_vue__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ThirdLayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ThirdLayer_vue__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Milestones',
	components: {
		Page: __WEBPACK_IMPORTED_MODULE_2__Page_vue___default.a,
		PriceTable: __WEBPACK_IMPORTED_MODULE_3__PriceTable_vue___default.a,
		Phase: __WEBPACK_IMPORTED_MODULE_4__Phase_vue___default.a,
		FirstLayer: __WEBPACK_IMPORTED_MODULE_5__FirstLayer_vue___default.a,
		SecondLayer: __WEBPACK_IMPORTED_MODULE_6__SecondLayer_vue___default.a,
		ThirdLayer: __WEBPACK_IMPORTED_MODULE_7__ThirdLayer_vue___default.a
	},
	props: {
		proposal: {
			type: Object,
			default: function _default() {
				return null;
			}
		}
	},

	data: function data() {
		return {
			milestones: this.proposal.milestones || {},
			pages: [],
			pageNum: 0,
			optionalPageNum: -1
		};
	},
	created: function created() {},

	watch: {
		proposal: function proposal(val) {
			console.log('Milestones got updated');
			this.milestones = val.milestones;
			this.structureMilestones(this.milestones);
		}
	},
	computed: {},
	methods: {
		// divide into "normal" and optional phases and set pages' structure
		structureMilestones: function structureMilestones(milestones) {
			try {
				var allPhases = milestones.items || [];
				var counter = 0;
				var counterOpt = 0;

				var phases = [[]];
				var optionalPhases = [[]];
				this.pages = [];
				this.optionalPageNum = -1;

				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(allPhases), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var milestone = _step.value;

						if (milestone.values.optional) {
							// if there should be a page break before Optional Phases
							if (optionalPhases.length === 1 && !optionalPhases[0].length && milestone.values.pageBreak) {
								this.optionalPageNum += 1;
							}
							this.pushPhases(milestone, optionalPhases, counterOpt);
							if (milestone.values.pageBreak) counterOpt++;
						} else {
							this.pushPhases(milestone, phases, counter);
							if (milestone.values.pageBreak) counter++;
						}

						// if milestone has page break INSIDE children
						if (milestone.children) {
							var _iteratorNormalCompletion2 = true;
							var _didIteratorError2 = false;
							var _iteratorError2 = undefined;

							try {
								for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(milestone.children), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
									var child = _step2.value;

									if (child.values.pageBreak) {
										if (milestone.values.optional) {
											counterOpt++;
											this.pushPhases(milestone, optionalPhases, counterOpt, true);
										} else {
											counter++;
											this.pushPhases(milestone, phases, counter, true);
										}
										break;
									}
								}
							} catch (err) {
								_didIteratorError2 = true;
								_iteratorError2 = err;
							} finally {
								try {
									if (!_iteratorNormalCompletion2 && _iterator2.return) {
										_iterator2.return();
									}
								} finally {
									if (_didIteratorError2) {
										throw _iteratorError2;
									}
								}
							}
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}

				this.optionalPageNum += phases.length;
				this.definePages(phases, optionalPhases);
			} catch (e) {
				console.log(e);
			}
		},


		// save milestone to pages (array of arrays)
		pushPhases: function pushPhases(milestone, phases, counter) {
			var pageBreakInside = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

			// if pagebreak set, create new array inside pages and push following pages there
			if (milestone.values.pageBreak || pageBreakInside) {
				var arr = [];

				if (pageBreakInside) {
					// make a copy of milestone for the next page
					var milestoneCopy = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(milestone));
					milestoneCopy.fromPrev = true;
					arr.push(milestoneCopy);
				} else {
					arr.push(milestone);
				}
				phases.push(arr);
			} else {
				phases[counter].push(milestone);
			}
		},


		// divide milestones into pages
		definePages: function definePages(phases, optionalPhases) {
			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;

			try {
				for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(phases), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var phase = _step3.value;

					this.pages.push({
						phases: phase
					});
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}

			var index = this.pages.length - 1;
			this.pages[index].table = true;

			for (var i = 0; i < optionalPhases.length; i++) {
				if (this.pages[index]) {
					this.pages[index].optionalPhases = optionalPhases[i];
				} else this.pages.push({
					optionalPhases: optionalPhases[i]
				});
				index++;
			}
		}
	},
	mounted: function mounted() {
		this.structureMilestones(this.milestones);
	}
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Page',
	props: {},
	components: {},
	data: function data() {
		return {};
	},
	created: function created() {},

	watch: {},
	computed: {},
	methods: {},

	mounted: function mounted() {}
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'MilestonePhase',
	props: {
		itemValues: {
			type: Object,
			default: function _default() {
				return {
					name: "",
					time: "",
					price: "",
					timeInDays: false,
					'Price-Long': "",
					'Time-Long': ""
				};
			}
		},
		milestones: {
			type: Object,
			default: function _default() {
				return {};
			}
		}
	},
	components: {},
	data: function data() {
		return {};
	},
	created: function created() {},

	watch: {},
	computed: {},

	methods: {},

	mounted: function mounted() {}
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Preloader',
	props: {
		content: {
			type: String,
			default: function _default() {
				return "";
			}
		}

	},
	data: function data() {
		return {};
	},
	mounted: function mounted() {},

	methods: {}
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        milestones: {
            type: Object,
            default: function _default() {
                return {};
            }
        }
    }
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'SecondLayer',
	props: {
		itemValues: {
			type: Object,
			default: function _default() {
				return {
					name: ""
				};
			}
		}
	},
	components: {},
	data: function data() {
		return {};
	},
	created: function created() {},

	watch: {},
	computed: {},
	methods: {},
	mounted: function mounted() {}
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ThirdLayer',
	props: {
		itemValues: {
			type: Object,
			default: function _default() {
				return {
					name: ""
				};
			}
		}
	},
	components: {},
	data: function data() {
		return {};
	},
	created: function created() {},


	computed: {},
	methods: {},

	mounted: function mounted() {}
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eventBus__ = __webpack_require__(40);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app',
	components: {},
	data: function data() {
		return {};
	},

	watch: {
		'$route': function $route(to, from) {
			if (to.name === "Builder") {
				console.log(to);
				__WEBPACK_IMPORTED_MODULE_1__eventBus__["a" /* default */].$emit("fadeInBuilder");
			}
		}
	}

});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_page_CoverPage_vue__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_page_CoverPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_page_CoverPage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_page_Milestones_vue__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_page_Milestones_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_page_Milestones_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_page_ConfirmationPage_vue__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_page_ConfirmationPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_page_ConfirmationPage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_page_Preloader_vue__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_page_Preloader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_page_Preloader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_functions__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(17);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Proposal',
	mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_functions__["a" /* func */]],
	props: {},
	components: {
		CoverPage: __WEBPACK_IMPORTED_MODULE_1__components_page_CoverPage_vue___default.a,
		Milestones: __WEBPACK_IMPORTED_MODULE_2__components_page_Milestones_vue___default.a,
		ConfirmationPage: __WEBPACK_IMPORTED_MODULE_3__components_page_ConfirmationPage_vue___default.a,
		Preloader: __WEBPACK_IMPORTED_MODULE_4__components_page_Preloader_vue___default.a
	},
	data: function data() {
		return {
			projectConfirmation: {},
			pageNum: 0,
			isLoading: true
		};
	},
	created: function created() {
		this.$store.dispatch('getAllCompanies');
	},

	watch: {},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])({
		proposal: 'proposal',
		companies: 'companies',
		mainCompany: 'mainCompany'
	}), {
		currentCompany: function currentCompany() {
			var _this = this;

			if (!this.proposal || !this.proposal['company-id'] || !this.companies.length) return null;
			return this.companies.find(function (c) {
				return c.id === _this.proposal['company-id'];
			}) || null;
		},
		resolvedCompany: function resolvedCompany() {
			var c = this.currentCompany;
			var m = this.mainCompany;
			if (!c && !m) return null;
			if (!m || c === m) return c;
			if (!c) return m;
			var addr = c.Address && (c.Address.Street || c.Address.City) ? c.Address : m.Address;
			var bank = c.BankDetails && (c.BankDetails.BankName || c.BankDetails.IBAN) ? c.BankDetails : m.BankDetails;
			return {
				Name: c.Name || m.Name,
				Type: c.Type || m.Type,
				isMain: !!c.isMain,
				InternalName: c.InternalName || m.InternalName,
				Logo: c.Logo || m.Logo,
				LogoName: c.LogoName || m.LogoName,
				LogoPosition: c.LogoPosition || m.LogoPosition,
				Address: addr,
				Phone: c.Phone || m.Phone,
				Fax: c.Fax,
				Email: c.Email || m.Email,
				Site: c.Site || m.Site,
				Owners: c.Owners || m.Owners,
				Registration: c.Registration || m.Registration,
				TaxNumber: c.TaxNumber || m.TaxNumber,
				BankDetails: bank
			};
		}
	}),
	methods: {
		loadProposal: function loadProposal(id) {
			this.$store.dispatch('getProposal', id);
		},
		backToBuilder: function backToBuilder() {
			__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push({
				name: 'Builder',
				params: {
					proposal: this.proposal
				},
				query: {
					proposal: this.proposal.id
				}
			});
		},
		printPage: function printPage() {
			window.print();
		},
		toggleButton: function toggleButton() {
			var state = {
				draft: 'pending',
				pending: 'accepted',
				accepted: 'updated',
				updated: 'rejected',
				rejected: 'draft'
			};
			this.proposal['Status'] = state[this.proposal['Status']] || false;
			this.$store.dispatch('updateProjectInfo', this.proposal);
		}
	},
	mounted: function mounted() {
		var _this2 = this;

		this.loadProposal(this.$route.query.proposal);

		setTimeout(function () {
			_this2.isLoading = false;
		}, 2000);
	}
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Set the configuration for your app
var config = {
	apiKey: "AIzaSyBqU_MDmTwv5RtyeovGhuz-lpLsKKK3k-4",
	authDomain: "cc-proposal-tool.firebaseapp.com",
	databaseURL: "https://cc-proposal-tool.firebaseio.com",
	projectId: "cc-proposal-tool",
	storageBucket: "cc-proposal-tool.appspot.com",
	messagingSenderId: "359594190366"
};

// Get a reference to the database service
var database = firebase.database();

/* harmony default export */ __webpack_exports__["a"] = ({
	getClients: function getClients(cb) {
		console.log('get Clients');
		var clients = firebase.database().ref('clients').orderByChild('timestamp');
		clients.on('value', function (snapshot) {
			var client = snapshot.val();
			if (client === null || client === undefined) {
				return;
			}
			cb(client);
		});
	},
	createClient: function createClient(client, cb) {
		console.log('create client');

		var mRef = firebase.database().ref('clients');
		var key = firebase.database().ref('clients').push().key;
		var newClient = firebase.database().ref('clients/' + key);

		newClient.set({
			id: key,
			"Client-Name": client['Client-Name'],
			"Contact-Person": client['Contact-Person'],
			"Street": client['Street'],
			"Place": client['Place']
		});

		newClient.once('value', function (snapshot) {
			var client = snapshot.val();
			if (client === null || client === undefined) {
				return;
			}
			cb(client);
		});
	},
	updateClient: function updateClient(clientInfo, cb) {
		console.log('update client');

		var clients = firebase.database().ref('clients');
		var client = clients.child(clientInfo.id);

		client.update({
			id: clientInfo.id,
			"Client-Name": clientInfo['Client-Name'],
			"Contact-Person": clientInfo['Contact-Person'],
			"Street": clientInfo['Street'],
			"Place": clientInfo['Place']
		});
	}
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	getCompanies: function getCompanies(cb) {
		var companies = firebase.database().ref('companies').orderByChild('timestamp');
		companies.on('value', function (snapshot) {
			var company = snapshot.val();
			if (company === null || company === undefined) return;
			cb(company);
		});
	},
	createCompany: function createCompany(company, cb) {
		var key = firebase.database().ref('companies').push().key;
		var newCompany = firebase.database().ref('companies/' + key);
		newCompany.set({
			id: key,
			"InternalName": company['InternalName'] || '',
			"LogoName": company['LogoName'] || (company['InternalName'] ? company['InternalName'].toLowerCase() + '.svg' : ''),
			"LogoPosition": company['LogoPosition'] || 'left',
			"Name": company['Name'] || '',
			"Address": {
				"Street": company['Address'] && company['Address']['Street'] || '',
				"House": company['Address'] && company['Address']['House'] || '',
				"PLZ": company['Address'] && company['Address']['PLZ'] || '',
				"City": company['Address'] && company['Address']['City'] || ''
			},
			"Phone": company['Phone'] || '',
			"Fax": company['Fax'] || '',
			"Email": company['Email'] || '',
			"Site": company['Site'] || '',
			"Logo": company['Logo'] || '',
			"Owners": company['Owners'] || '',
			"Registration": company['Registration'] || '',
			"TaxNumber": company['TaxNumber'] || '',
			"Type": company['Type'] || '',
			"isMain": company['isMain'] || false,
			"BankDetails": {
				"BankName": company['BankDetails'] && company['BankDetails']['BankName'] || '',
				"IBAN": company['BankDetails'] && company['BankDetails']['IBAN'] || '',
				"BIC": company['BankDetails'] && company['BankDetails']['BIC'] || ''
			},
			"timestamp": Date.now()
		});
		newCompany.once('value', function (snapshot) {
			var saved = snapshot.val();
			if (saved === null || saved === undefined) return;
			cb(saved);
		});
	},
	updateCompany: function updateCompany(company, cb) {
		var ref = firebase.database().ref('companies').child(company.id);
		ref.update({
			id: company.id,
			"InternalName": company['InternalName'] || '',
			"LogoName": company['LogoName'] || '',
			"LogoPosition": company['LogoPosition'] || 'left',
			"Name": company['Name'] || '',
			"Address": {
				"Street": company['Address'] && company['Address']['Street'] || '',
				"House": company['Address'] && company['Address']['House'] || '',
				"PLZ": company['Address'] && company['Address']['PLZ'] || '',
				"City": company['Address'] && company['Address']['City'] || ''
			},
			"Phone": company['Phone'] || '',
			"Fax": company['Fax'] || '',
			"Email": company['Email'] || '',
			"Site": company['Site'] || '',
			"Logo": company['Logo'] || '',
			"Owners": company['Owners'] || '',
			"Registration": company['Registration'] || '',
			"TaxNumber": company['TaxNumber'] || '',
			"Type": company['Type'] || '',
			"isMain": company['isMain'] || false,
			"BankDetails": {
				"BankName": company['BankDetails'] && company['BankDetails']['BankName'] || '',
				"IBAN": company['BankDetails'] && company['BankDetails']['IBAN'] || '',
				"BIC": company['BankDetails'] && company['BankDetails']['BIC'] || ''
			}
		});
		if (cb) cb(company);
	},
	removeCompany: function removeCompany(id, cb) {
		firebase.database().ref('companies/' + id).remove();
		if (cb) cb(id);
	}
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Set the configuration for your app
var CONFIG = {
	apiKey: "AIzaSyBqU_MDmTwv5RtyeovGhuz-lpLsKKK3k-4",
	authDomain: "cc-proposal-tool.firebaseapp.com",
	databaseURL: "https://cc-proposal-tool.firebaseio.com",
	projectId: "cc-proposal-tool",
	storageBucket: "cc-proposal-tool.appspot.com",
	messagingSenderId: "359594190366"
};

var provider = new firebase.auth.GoogleAuthProvider();

firebase.initializeApp(CONFIG);

// Get a reference to the database service
var proposals = {
	getProposals: function getProposals(cb) {
		console.log('get all Proposals');

		var proposals = firebase.database().ref('proposals').orderByChild('timestamp');

		proposals.on('value', function (snapshot) {
			var proposals = snapshot.val();

			if (proposals === null || proposals === undefined) {
				cb([]);
				return;
			}
			cb(proposals);
		});
	},
	getProposal: function getProposal(id, cb) {
		console.log('get Proposal');

		var proposal = firebase.database().ref('proposals').child(id);

		proposal.off('value');
		proposal.on('value', function (snapshot) {
			var proposal = snapshot.val();
			if (proposal === null || proposal === undefined) {
				return;
			}
			cb(proposal);
		});
	},
	offProposal: function offProposal(id) {
		firebase.database().ref('proposals').child(id).off('value');
	},
	updateProjectInfo: function updateProjectInfo(proposalInfo, cb) {
		console.log('update Proposal Info', proposalInfo['Status']);

		var proposals = firebase.database().ref('proposals');
		var proposal = proposals.child(proposalInfo.id);

		proposal.update({
			id: proposalInfo.id,
			"Internal-Name": proposalInfo['Internal-Name'] || '',
			"Type": proposalInfo['Type'],
			"Client-Name": proposalInfo['Client-Name'],
			"Contact-Person": proposalInfo['Contact-Person'],
			"Street": proposalInfo['Street'],
			"Place": proposalInfo['Place'],
			"Project-Number": proposalInfo['Project-Number'],
			"Project-Description": proposalInfo['Project-Description'],
			"Updated-Project-Id": proposalInfo['Updated-Project-Id'] || '',
			"Predecessor-Project-Id": proposalInfo['Predecessor-Project-Id'] || '',
			"Date": proposalInfo['Date'],
			"Status": proposalInfo['Status'] || 'draft',
			"company-id": proposalInfo['company-id'] || '',
			"Logo-Position": proposalInfo['Logo-Position'] || 'left'
		});
	},
	updateConfirmation: function updateConfirmation(data) {
		console.log('update Proposal Confirmation');

		firebase.database().ref('proposals').child(data.id).update({
			"Project-Confirmation": data['Project-Confirmation']
		});
	},
	updateMilestones: function updateMilestones(milestones, id, cb) {
		console.log('update Milestones');

		firebase.database().ref('proposals').child(id).update({
			"milestones": milestones
		});
	},
	createProposal: function createProposal(proposal, cb) {
		console.log('Create Proposal');

		var mRef = firebase.database().ref('proposals');
		var key = firebase.database().ref('proposals').push().key;
		var newProposal = firebase.database().ref('proposals/' + key);
		newProposal.set({
			id: key,
			"Internal-Name": proposal['Internal-Name'] || '',
			"Type": proposal['Type'] || 'Angebot',
			"Client-Name": proposal['Client-Name'],
			"Contact-Person": proposal['Contact-Person'],
			"Street": proposal['Street'],
			"Place": proposal['Place'],
			"Project-Number": proposal['Project-Number'],
			"Project-Description": proposal['Project-Description'],
			"Project-Confirmation": proposal['Project-Confirmation'],
			"Updated-Project-Id": proposal['Updated-Project-Id'] || '',
			"Predecessor-Project-Id": proposal['Predecessor-Project-Id'] || '',
			"Status": proposal['Status'],
			"Date": proposal['Date'],
			"timestamp": proposal['timestamp'],
			"milestones": proposal['milestones'],
			"company-id": proposal['company-id'] || ''
		});
		newProposal.once('value', function (snapshot) {
			var proposal = snapshot.val();
			if (proposal === null || proposal === undefined) {
				return;
			}
			cb(proposal);
		});
	},
	duplicateProposal: function duplicateProposal(id, cb) {
		console.log('duplicate Proposal');

		firebase.database().ref('proposals/' + id).once('value').then(function (snapshot) {
			var proposal = snapshot.val();
			console.log(proposal);
			var newID = firebase.database().ref('proposals').push(proposal).key;
			var newProposal = firebase.database().ref('proposals').child(newID);

			newProposal.update({
				id: newID,
				"Internal-Name": proposal['Internal-Name'] + ' copy',
				"Project-Number": '',
				"Predecessor-Project-Id": proposal.id,
				"Date": '',
				Status: "draft"
			});

			newProposal.once('value', function (snapshot) {
				var proposal = snapshot.val();
				if (proposal === null || proposal === undefined) {
					return;
				}
				if (cb) cb(proposal);
			});
		});
	},
	removeProposal: function removeProposal(id) {
		console.log('Remove Proposal');
		console.log(id);
		firebase.database().ref('proposals').child(id).remove();
	}
};

/* harmony default export */ __webpack_exports__["a"] = (proposals);

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store___ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_App__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_App__);
// The Vue build version to load with the `import` command (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: '#app',
	created: function created() {
		window.Vue = this;
	},
	router: __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */],
	store: __WEBPACK_IMPORTED_MODULE_2__store___["a" /* default */],
	render: function render(h) {
		return h(__WEBPACK_IMPORTED_MODULE_3__pages_App___default.a);
	}
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = ({
	inputData: new Object()
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_proposals__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_clients__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_companies__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mutation_types__ = __webpack_require__(89);








var _mutations;






// initial state
var state = {
	proposal: {},
	proposals: [],
	milestones: {},
	clients: [],
	client: {},
	companies: [],
	company: {}

	// getters
};var getters = {
	clients: function clients(state) {
		return state.clients;
	},
	client: function client(state) {
		return state.client;
	},
	companies: function companies(state) {
		return state.companies;
	},
	company: function company(state) {
		return state.company;
	},
	mainCompany: function mainCompany(state) {
		return state.companies.find(function (c) {
			return c.isMain;
		}) || null;
	},
	allProposals: function allProposals(state) {
		return state.proposals;
	},
	proposal: function proposal(state) {
		return state.proposal;
	},
	milestones: function milestones(state) {
		var milestones = state.proposal.milestones;

		if (!milestones) {
			milestones = {};
		}
		if (!milestones.items) {
			milestones.items = [];
		}
		return milestones;
	}

	// actions
};var actions = {
	initialState: function initialState(_ref) {
		var commit = _ref.commit;

		state.client = {};
		state.proposal = {};
	},
	createClient: function createClient(_ref2, payload) {
		var commit = _ref2.commit;

		var obj = payload;
		__WEBPACK_IMPORTED_MODULE_8__api_clients__["a" /* default */].createClient(obj, function () {
			return commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["a" /* CREATE_CLIENT */], { obj: obj });
		});
	},
	updateClient: function updateClient(_ref3, payload) {
		var commit = _ref3.commit;

		var obj = payload;
		__WEBPACK_IMPORTED_MODULE_8__api_clients__["a" /* default */].updateClient(obj, function () {
			return commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["b" /* UPDATE_CLIENT */], { obj: obj });
		});
	},
	setClient: function setClient(_ref4, payload) {
		var commit = _ref4.commit;

		var client = payload;
		commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["c" /* SET_CLIENT */], { client: client });
	},
	getAllClients: function getAllClients(_ref5) {
		var commit = _ref5.commit;

		__WEBPACK_IMPORTED_MODULE_8__api_clients__["a" /* default */].getClients(function (clients) {
			commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["d" /* RECEIVE_CLIENTS */], { clients: clients });
		});
	},
	getAllCompanies: function getAllCompanies(_ref6) {
		var commit = _ref6.commit;

		__WEBPACK_IMPORTED_MODULE_9__api_companies__["a" /* default */].getCompanies(function (data) {
			commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["e" /* RECEIVE_COMPANIES */], { data: data });
		});
	},
	createCompany: function createCompany(_ref7, payload) {
		var commit = _ref7.commit;

		__WEBPACK_IMPORTED_MODULE_9__api_companies__["a" /* default */].createCompany(payload, function (company) {
			return commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["f" /* CREATE_COMPANY */], { company: company });
		});
	},
	updateCompany: function updateCompany(_ref8, payload) {
		var commit = _ref8.commit;

		__WEBPACK_IMPORTED_MODULE_9__api_companies__["a" /* default */].updateCompany(payload, function (company) {
			return commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["g" /* UPDATE_COMPANY */], { company: company });
		});
	},
	removeCompany: function removeCompany(_ref9, payload) {
		var commit = _ref9.commit;

		__WEBPACK_IMPORTED_MODULE_9__api_companies__["a" /* default */].removeCompany(payload, function (id) {
			return commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["h" /* REMOVE_COMPANY */], { id: id });
		});
	},
	getAllProposals: function getAllProposals(_ref10) {
		var commit = _ref10.commit;

		__WEBPACK_IMPORTED_MODULE_7__api_proposals__["a" /* default */].getProposals(function (proposals) {
			commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["i" /* RECEIVE_PROPOSALS */], { proposals: proposals });
		});
	},
	getProposal: function getProposal(_ref11, proposalID) {
		var commit = _ref11.commit;

		var id = proposalID;
		__WEBPACK_IMPORTED_MODULE_7__api_proposals__["a" /* default */].getProposal(id, function (proposal) {
			if (state.proposal.id && state.proposal.id !== id) return;
			if (!proposal['Type']) proposal['Type'] = 'Angebot';
			commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["j" /* RECEIVE_PROPOSAL */], { proposal: proposal });
		});
	},
	offProposal: function offProposal(_ref12, proposalID) {
		var commit = _ref12.commit;

		__WEBPACK_IMPORTED_MODULE_7__api_proposals__["a" /* default */].offProposal(proposalID);
	},
	createProposal: function createProposal(_ref13, payload) {
		var commit = _ref13.commit;

		var obj = payload;
		console.log(obj);
		__WEBPACK_IMPORTED_MODULE_7__api_proposals__["a" /* default */].createProposal(obj, function (proposal) {
			return commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["k" /* CREATE_PROPOSAL */], { proposal: proposal });
		});
	},
	duplicateProposal: function duplicateProposal(_ref14, payload) {
		var commit = _ref14.commit;

		var id = payload;
		__WEBPACK_IMPORTED_MODULE_7__api_proposals__["a" /* default */].duplicateProposal(id);
	},
	removeProposal: function removeProposal(_ref15, payload) {
		var commit = _ref15.commit;

		var id = payload;
		__WEBPACK_IMPORTED_MODULE_7__api_proposals__["a" /* default */].removeProposal(id, function () {
			return commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["l" /* REMOVE_PROPOSAL */], { id: id });
		});
	},
	updateProjectInfo: function updateProjectInfo(_ref16, payload) {
		var commit = _ref16.commit;

		var obj = payload;
		__WEBPACK_IMPORTED_MODULE_7__api_proposals__["a" /* default */].updateProjectInfo(obj, function () {
			return commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["m" /* UPDATE_PROJECT_INFO */], { obj: obj });
		});
	},
	updateConfirmation: function updateConfirmation(_ref17, payload) {
		var commit = _ref17.commit;

		var obj = payload;
		__WEBPACK_IMPORTED_MODULE_7__api_proposals__["a" /* default */].updateConfirmation(obj, function () {
			return commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["n" /* UPDATE_CONFIRMATION */], { obj: obj });
		});
	},
	updateMilestones: function updateMilestones(_ref18, payload) {
		var commit = _ref18.commit;

		var obj = payload.milestones;
		var id = payload.id;
		__WEBPACK_IMPORTED_MODULE_7__api_proposals__["a" /* default */].updateMilestones(obj, id, function () {
			return commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["o" /* UPDATE_MILESTONES */], { obj: obj });
		});
	},
	addPhase: function addPhase(_ref19, payload) {
		var commit = _ref19.commit;

		var milestone = payload;
		commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["p" /* ADD_PHASE */], { milestone: milestone });
	},
	addChild: function addChild(_ref20, payload) {
		var commit = _ref20.commit;

		var childValue = payload;
		commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["q" /* ADD_CHILD */], { childValue: childValue });
	},
	addSibling: function addSibling(_ref21, payload) {
		var commit = _ref21.commit;

		var childValue = payload;
		commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["r" /* ADD_SIBLING */], { childValue: childValue });
	},
	removeTile: function removeTile(_ref22, payload) {
		var commit = _ref22.commit;

		var id = payload;
		commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["s" /* REMOVE_TILE */], { id: id });
	},
	switchWithUpperSibling: function switchWithUpperSibling(_ref23, payload) {
		var commit = _ref23.commit;

		var id = payload;
		commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["t" /* SWITCH_WITH_UPPER_SIBLING */], { id: id });
	},
	switchWithLowerSibling: function switchWithLowerSibling(_ref24, payload) {
		var commit = _ref24.commit;

		var id = payload;
		commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["u" /* SWITCH_WITH_LOWER_SIBLING */], { id: id });
	},
	shiftIn: function shiftIn(_ref25, payload) {
		var commit = _ref25.commit;

		var id = payload;
		commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["v" /* SHIFT_IN */], { id: id });
	},
	shiftOut: function shiftOut(_ref26, payload) {
		var commit = _ref26.commit;

		var id = payload;
		commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["w" /* SHIFT_OUT */], { id: id });
	},
	updatePrice: function updatePrice(_ref27) {
		var commit = _ref27.commit;

		commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["x" /* UPDATE_PRICE */]);
	},
	updateTime: function updateTime(_ref28) {
		var commit = _ref28.commit;

		commit(__WEBPACK_IMPORTED_MODULE_10__mutation_types__["y" /* UPDATE_TIME */]);
	}
};

// mutations
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["e" /* RECEIVE_COMPANIES */], function (state, _ref29) {
	var data = _ref29.data;

	var arr = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(data).map(function (key) {
		return data[key];
	});
	state.companies = arr.reverse();
}), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["f" /* CREATE_COMPANY */], function (state, _ref30) {
	var company = _ref30.company;

	state.company = company;
}), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["g" /* UPDATE_COMPANY */], function (state, _ref31) {
	var company = _ref31.company;

	state.company = company;
	var idx = state.companies.findIndex(function (c) {
		return c.id === company.id;
	});
	if (idx !== -1) state.companies.splice(idx, 1, company);
}), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["h" /* REMOVE_COMPANY */], function (state, _ref32) {
	var id = _ref32.id;

	state.companies = state.companies.filter(function (c) {
		return c.id !== id;
	});
}), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["a" /* CREATE_CLIENT */], function (state, _ref33) {
	var client = _ref33.client;

	state.client = client;
}), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["b" /* UPDATE_CLIENT */], function (state, _ref34) {
	var client = _ref34.client;

	state.proposal['Client-Name'] = client['Client-Name'];
	state.proposal['Contact-Person'] = client['Contact-Person'];
	state.proposal['Place'] = client['Place'];
	state.proposal['Street'] = client['Street'];
}), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["c" /* SET_CLIENT */], function (state, _ref35) {
	var client = _ref35.client;

	state.client = client;
	state.proposal['Client-Name'] = client['Client-Name'];
	state.proposal['Contact-Person'] = client['Contact-Person'];
	state.proposal['Place'] = client['Place'];
	state.proposal['Street'] = client['Street'];
}), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["d" /* RECEIVE_CLIENTS */], function (state, _ref36) {
	var clients = _ref36.clients;

	var arr = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(clients).map(function (key) {
		return clients[key];
	});
	state.clients = arr.reverse();
}), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["i" /* RECEIVE_PROPOSALS */], function (state, _ref37) {
	var proposals = _ref37.proposals;

	var arr = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(proposals).map(function (key) {
		return proposals[key];
	});
	state.proposals = arr.reverse();
}), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["j" /* RECEIVE_PROPOSAL */], function (state, _ref38) {
	var proposal = _ref38.proposal;

	state.proposal = proposal;
	state.milestones = proposal.milestones;
}), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["k" /* CREATE_PROPOSAL */], function (state, _ref39) {
	var proposal = _ref39.proposal;

	state.proposal = proposal;
	state.milestones = proposal['milestones'];
}), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["l" /* REMOVE_PROPOSAL */], function (state, _ref40) {
	var id = _ref40.id;

	state.proposal = {};
	state.milestones = {};
}), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["m" /* UPDATE_PROJECT_INFO */], function (state, _ref41) {
	var obj = _ref41.obj;

	updateProjectInfo(state, obj);
}), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["n" /* UPDATE_CONFIRMATION */], function (state, _ref42) {
	var obj = _ref42.obj;

	updateConfirmation(state, obj);
}), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["o" /* UPDATE_MILESTONES */], function (state, _ref43) {
	var obj = _ref43.obj;

	updateMilestones(state, obj);
}), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["p" /* ADD_PHASE */], function (state, _ref44) {
	var milestone = _ref44.milestone;

	addPhase(state, milestone);
}), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["q" /* ADD_CHILD */], function (state, _ref45) {
	var childValue = _ref45.childValue;

	addChild(state, childValue);
}), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["r" /* ADD_SIBLING */], function (state, _ref46) {
	var childValue = _ref46.childValue;

	addSibling(state, childValue);
}), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["t" /* SWITCH_WITH_UPPER_SIBLING */], function (state, _ref47) {
	var id = _ref47.id;

	switchWithUpperSibling(state, id);
}), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["u" /* SWITCH_WITH_LOWER_SIBLING */], function (state, _ref48) {
	var id = _ref48.id;

	switchWithLowerSibling(state, id);
}), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["w" /* SHIFT_OUT */], function (state, _ref49) {
	var id = _ref49.id;

	shiftOut(state, id);
}), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["v" /* SHIFT_IN */], function (state, _ref50) {
	var id = _ref50.id;

	shiftIn(state, id);
}), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["s" /* REMOVE_TILE */], function (state, _ref51) {
	var id = _ref51.id;

	removeTile(state, id);
}), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["x" /* UPDATE_PRICE */], function (state) {
	updatePrice(state);
}), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["y" /* UPDATE_TIME */], function (state) {
	updateTime(state);
}), _mutations);

function updateProjectInfo(state, obj) {
	var projectIproposalnfo = state.proposal;
	console.log(obj);

	proposal = obj;
	// projectInfo[key] = projectInfo[key] || {}; projectInfo[key] = value;
}

function updateConfirmation(state, obj) {
	var confirmation = state.confirmation;
	var key = obj.key;
	var value = obj.value;

	confirmation[key] = confirmation[key] || {};
	confirmation[key] = value;
}

function updateMilestones(state, obj) {
	var milestones = state.milestones;
	milestones = obj.milestones;
}

function addPhase(state, milestone) {
	setID(state, milestone);

	if (!state.milestones.items) {
		state.milestones.items = [];
	}
	state.milestones.items.push(milestone);
}

function addChild(state, child) {
	var milestones = state.milestones.items;
	var parentID = child.values.parentID;
	var parent = findByID(milestones, parentID);

	setID(state, child);

	if (!parent.children) {
		parent.children = [];
	}
	parent.children.push(child);
}

function addSibling(state, child) {
	var milestones = state.milestones.items;
	var parentID = child.values.parentID;
	var parent = findByID(milestones, parentID);
	var grandParent = findByID(milestones, parent.values.parentID);

	child.values.parentID = parent.values.parentID;
	setID(state, child);

	// add phase
	if (!grandParent) {
		milestones.push(child);
		milestones = changeItemPositionInArr(milestones, findIndex(milestones, child.id), findIndex(milestones, parentID) + 1);
		// add milestone/bulletpoint
	} else {
		if (!grandParent.children) {
			grandParent.children = [];
		}
		grandParent.children.push(child);
		grandParent.children = changeItemPositionInArr(grandParent.children, findIndex(grandParent.children, child.id), findIndex(grandParent.children, parentID) + 1);
	}
}

function switchWithUpperSibling(state, id) {
	var milestones = state.milestones.items;
	var child = findByID(milestones, id);
	var parent = findByID(milestones, child.values.parentID);

	if (!parent) {
		var childIndex = milestones.findIndex(function (item) {
			return item.id !== undefined && item.id === id;
		});
		if (childIndex !== 0) {
			milestones = swapArrayItems(milestones, childIndex - 1, childIndex);
		}
	} else if (parent.children.length > 1) {
		var _childIndex = parent.children.findIndex(function (item) {
			return item.id === id;
		});
		if (_childIndex !== 0) {
			parent = swapArrayItems(parent.children, _childIndex - 1, _childIndex);
		}
	}
}

function switchWithLowerSibling(state, id) {
	var milestones = state.milestones.items;
	var child = findByID(milestones, id);
	var parent = findByID(milestones, child.values.parentID);

	if (!parent) {
		var childIndex = milestones.findIndex(function (item) {
			return item.id !== undefined && item.id === id;
		});
		if (childIndex !== milestones.length - 1) {
			milestones = swapArrayItems(milestones, childIndex, childIndex + 1);
		}
	} else if (parent.children.length > 1) {
		var _childIndex2 = parent.children.findIndex(function (item) {
			return item.id === id;
		});
		if (_childIndex2 !== parent.children.length - 1) {
			parent = swapArrayItems(parent.children, _childIndex2, _childIndex2 + 1);
		}
	}
}

function shiftIn(state, id) {
	var milestones = state.milestones.items;
	var child = findByID(milestones, id);
	var parent = findByID(milestones, child.values.parentID);
	var childIndex = 0;
	console.log(parent, milestones);

	if (!parent) {
		if (milestones.length <= 1) return;

		childIndex = milestones.findIndex(function (item) {
			return item.id === id;
		});
		var newParent = milestones[childIndex - 1];

		if (!newParent) return;

		removeTile(state, id);
		child.values.parentID = newParent.id;
		if (newParent.children == undefined) {
			newParent.children = [];
		}
		newParent.children.push(child);
	} else {
		childIndex = parent.children.findIndex(function (item) {
			return item.id === id;
		});
		var _newParent = parent.children[childIndex - 1];

		if (!_newParent) return;

		removeTile(state, id);
		child.values.parentID = _newParent.id;

		if (_newParent.children == undefined) {
			_newParent.children = [];
		}
		_newParent.children.push(child);
	}
}

function shiftOut(state, id) {
	var milestones = state.milestones.items;
	var child = findByID(milestones, id);

	//no parent
	if (!child.values.parentID) return;

	var parent = findByID(milestones, child.values.parentID);
	var grandParent = findByID(milestones, parent.values.parentID);
	removeTile(state, id);

	child.values.parentID = parent.values.parentID;

	//shiftOut to phase
	if (grandParent == null) {
		milestones.push(child);
	} else {
		grandParent.children.push(child);
	}
}

function removeTile(state, id) {
	var milestones = state.milestones.items;
	var child = findByID(milestones, id);
	var parent = findByID(milestones, child.values.parentID);
	var childIndex = 0;

	if (!parent) {
		childIndex = milestones.findIndex(function (item) {
			return item.id === id;
		});
		milestones.splice(childIndex, 1);
		return;
	}

	childIndex = parent.children.findIndex(function (item) {
		return item.id === id;
	});
	parent.children.splice(childIndex, 1);
}

function updatePrice(state) {
	var milestones = state.milestones;
	console.log('updating price');
	var price = 0;
	var taxes = {
		'5': 0,
		'7': 0,
		'16': 0,
		'19': 0
	};
	var indices_notNumber = [];
	var optionalNum = 0;

	// find total price and taxes for all milestones
	for (var i = 0; i < milestones.items.length; i++) {
		var phase = milestones.items[i];
		var value = Number(phase.values.price);

		// save indices of phases with no number values in price field
		if (isNaN(value)) {
			indices_notNumber.push(i);
			continue;
		}

		phase.values['Price-Long'] = convertToCurrency(value);

		if (phase.values.optional) {
			optionalNum += 1;
			continue;
		}

		price += value;
		findTaxes(value, phase, taxes);

		var children = parent.children;
		if (!children) continue;

		for (var _i = 0; _i < children.length; _i++) {
			var child = children[_i];
			var _value = Number(child.values.price);

			if (isNaN(_value) == NaN) continue;

			price += _value;
		}
	}

	// find % value in euro and update total price
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(indices_notNumber), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var _i2 = _step.value;

			var _phase = milestones.items[_i2];
			var _value2 = _phase.values.price;

			if (_value2[_value2.length - 1] !== '%') continue;
			_value2 = price * parseInt(_value2) / 100;
			_phase.values['Price-Long'] = convertToCurrency(_value2);

			if (_phase.values.optional) {
				optionalNum += 1;
				continue;
			}

			price += _value2;
			findTaxes(_value2, _phase, taxes);
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	if (!indices_notNumber.length) {
		milestones['has-Percent-Phase'] = false;
	}

	// write all values to milestones properties
	if (!isNaN(price)) milestones.Price = price;
	milestones['Price-Netto'] = convertToCurrency(price);
	milestones['Price-Brutto'] = convertToCurrency(price + __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(taxes).reduce(function (pv, cv) {
		return pv + cv;
	}, 0));

	// convert taxes values to strings and save them in Taxes-X-Long milestones properties
	var _iteratorNormalCompletion2 = true;
	var _didIteratorError2 = false;
	var _iteratorError2 = undefined;

	try {
		for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(taxes)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
			var _ref52 = _step2.value;

			var _ref53 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref52, 2);

			var taxes_key = _ref53[0];
			var taxes_value = _ref53[1];

			milestones['Taxes-' + taxes_key + '-Long'] = taxes_value > 0 ? convertToCurrency(taxes_value) : 0;
		}
	} catch (err) {
		_didIteratorError2 = true;
		_iteratorError2 = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion2 && _iterator2.return) {
				_iterator2.return();
			}
		} finally {
			if (_didIteratorError2) {
				throw _iteratorError2;
			}
		}
	}
}

function findTaxes(value, phase, taxes) {
	var taxes_val = phase.values.taxes;

	if (taxes_val !== undefined) {
		// if milestone already has type of taxes set in property
		taxes[taxes_val] += value * taxes_val / 100;
	} else if (phase.values['Taxes-19']) {
		// if old system is used (only 7/19%)
		taxes['19'] += value * 0.19;
	} else {
		taxes['7'] += value * 0.07;
	}
}

function updateTime(state) {
	var milestones = state.milestones;
	var time = 0;
	var timeOptional = 0;
	milestones['Time-Optional'] = 0;

	for (var i = 0; i < milestones.items.length; i++) {
		var phase = milestones.items[i];
		var value = Number(phase.values.time);
		if (isNaN(value)) continue;

		phase.values['Time-Long'] = convertToWeek(value);

		if (phase.values.optional) {
			console.log(milestones['Time-Optional'], { value: value });
			timeOptional += value;
		} else {
			time += value;

			var children = phase.children;
			if (!children) continue;

			for (var _i3 = 0; _i3 < children.length; _i3++) {
				var child = children[_i3];
				var _value3 = Number(child.values.time);

				if (isNaN(_value3)) continue;

				time += _value3;
			}
		}
	}

	milestones['Time'] = time;
	milestones['Time-Optional'] = timeOptional;
	milestones['Time-Long'] = convertToWeek(time);
}

function convertToCurrency(price) {
	var currency = price.toFixed(2).replace(/./g, function (c, i, a) {
		if (i && c !== "." && (a.length - i) % 3 === 0) {
			return ',' + c;
		} else {
			return c;
		}
	});

	currency = currency.replace(",", ".");

	var pos = currency.lastIndexOf('.');
	currency = "€ " + currency.substring(0, pos) + ',' + currency.substring(pos + 1);

	return currency;
}

function convertToWeek(value) {
	if (value === "") {
		return "";
	}
	value = String(value) || "";
	if (value.indexOf("Woche") === -1) {
		if (value === "1") {
			value += " Woche";
		} else {
			value += " Wochen";
		}
	}
	return value.replace(".", ",");
}

function convertToDays(value) {
	if (value === "") {
		return "";
	}
	value = String(value) || "";
	if (value.indexOf("Tage") === -1) {
		if (value === "1") {
			value += " Tag";
		} else {
			value += " Tage";
		}
	}
	return value;
}

// swap array items at positions i and j
function swapArrayItems(list, i, j) {
	var mList = list;
	var _ref54 = [mList[j], mList[i]];
	mList[i] = _ref54[0];
	mList[j] = _ref54[1];

	return mList;
}

// move item in array from position fromIndex to position toIndex
function changeItemPositionInArr(list, fromIndex, toIndex) {
	var mList = list;
	mList.splice(toIndex, 0, mList.splice(fromIndex, 1)[0]);
	return mList;
}

function findByID(o, id) {
	if (o.id === id) {
		return o;
	}
	var result = void 0;
	var p = void 0;

	for (p in o) {
		if (o.hasOwnProperty(p) && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(o[p]) === 'object') {
			result = findByID(o[p], id);
			if (result) {
				return result;
			}
		}
	}
	return result;
}

function setID(state, self) {
	self.id = ++state.milestones.id;

	//update every child.parentID to new parent id
	for (var child in self.children) {
		child.values.parentID = self.id;
	}
}

// find index of item with id
function findIndex(list, id) {
	return list.findIndex(function (item) {
		return item.id !== undefined && item.id === id;
	});
}

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	getters: getters,
	actions: actions,
	mutations: mutations
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RECEIVE_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return RECEIVE_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CREATE_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return REMOVE_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return UPDATE_PROJECT_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return UPDATE_MILESTONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ADD_PHASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ADD_CHILD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return ADD_SIBLING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return REMOVE_TILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SWITCH_WITH_UPPER_SIBLING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SWITCH_WITH_LOWER_SIBLING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SHIFT_OUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SHIFT_IN; });
/* unused harmony export UPDATE_MILESTONE_JSON */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return UPDATE_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return UPDATE_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return UPDATE_CONFIRMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RECEIVE_CLIENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPDATE_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RECEIVE_COMPANIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CREATE_COMPANY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UPDATE_COMPANY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return REMOVE_COMPANY; });
//DASHBOARD
var RECEIVE_PROPOSALS = 'RECEIVE_PROPOSALS';
var RECEIVE_PROPOSAL = 'RECEIVE_PROPOSAL';
var CREATE_PROPOSAL = 'CREATE_PROPOSAL';
var REMOVE_PROPOSAL = 'REMOVE_PROPOSAL';

//APP
var UPDATE_PROJECT_INFO = 'UPDATE_PROJECT_INFO';
var UPDATE_MILESTONES = 'UPDATE_MILESTONES';

var ADD_PHASE = 'ADD_PHASE';
var ADD_CHILD = 'ADD_CHILD';
var ADD_SIBLING = 'ADD_SIBLING';
var REMOVE_TILE = 'REMOVE_TILE';
var SWITCH_WITH_UPPER_SIBLING = 'SWITCH_WITH_UPPER_SIBLING';
var SWITCH_WITH_LOWER_SIBLING = 'SWITCH_WITH_LOWER_SIBLING';
var SHIFT_OUT = 'SHIFT_OUT';
var SHIFT_IN = 'SHIFT_IN';
var UPDATE_MILESTONE_JSON = 'UPDATE_MILESTONE_JSON';

var UPDATE_TIME = 'UPDATE_TIME';
var UPDATE_PRICE = 'UPDATE_PRICE';

var UPDATE_CONFIRMATION = 'UPDATE_CONFIRMATION';

//CLIENTS
var RECEIVE_CLIENTS = 'RECEIVE_CLIENTS';
var SET_CLIENT = 'SET_CLIENT';
var UPDATE_CLIENT = 'UPDATE_CLIENT';
var CREATE_CLIENT = 'CREATE_CLIENT';

//COMPANIES
var RECEIVE_COMPANIES = 'RECEIVE_COMPANIES';
var CREATE_COMPANY = 'CREATE_COMPANY';
var UPDATE_COMPANY = 'UPDATE_COMPANY';
var REMOVE_COMPANY = 'REMOVE_COMPANY';

/***/ }),
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(140)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(167),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(135)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(162),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(133)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(72),
  /* template */
  __webpack_require__(159),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1b81bb3d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(143)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(73),
  /* template */
  __webpack_require__(170),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(134)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(75),
  /* template */
  __webpack_require__(160),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(138)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(165),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(137)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(78),
  /* template */
  __webpack_require__(164),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-51b18d9e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(139)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(166),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-68652666",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(161),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(141)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(168),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.company) ? _c('div', {
    staticClass: "CompanyInfo"
  }, [_c('div', {
    staticClass: "Col"
  }, [_c('p', [_vm._v("\n            " + _vm._s(_vm.company.Name) + " " + _vm._s(_vm.company.Type) + "\n\t\t")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("Sitz der Gesellschaft:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.company.Address && _vm.company.Address.Street) + " " + _vm._s(_vm.company.Address && _vm.company.Address.House))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.company.Address && _vm.company.Address.PLZ) + " " + _vm._s(_vm.company.Address && _vm.company.Address.City))])])]), _vm._v(" "), _c('div', {
    staticClass: "Col"
  }, [_c('p', [_c('span', [_c('span', [_vm._v("Tel. ")]), _c('span'), _vm._v(_vm._s(_vm.company.Phone))]), _vm._v(" "), (_vm.company.Fax) ? _c('span', [_c('span', [_vm._v("Fax ")]), _c('span'), _vm._v(_vm._s(_vm.company.Fax))]) : _vm._e()]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": 'mailto:' + _vm.company.Email
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.company.Email))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.company.Site
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.company.Site))])])])]), _vm._v(" "), _c('div', {
    staticClass: "Col"
  }, [_c('p', [_c('span', [_vm._v("Geschäftsführer:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.company.Owners))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.company.Registration))])])]), _vm._v(" "), _c('div', {
    staticClass: "Col"
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.company.BankDetails && _vm.company.BankDetails.BankName))]), _vm._v(" "), _c('span', {
    staticClass: "CompanyInfo-Iban"
  }, [_c('span', [_vm._v("IBAN: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.company.BankDetails && _vm.company.BankDetails.IBAN))])]), _vm._v(" "), _c('span', [_vm._v("BIC: " + _vm._s(_vm.company.BankDetails && _vm.company.BankDetails.BIC))]), _vm._v(" "), _c('span', [_vm._v("USt-IdNr.: " + _vm._s(_vm.company.TaxNumber))])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "FirstLayer",
    class: {
      "Bulletpoint": _vm.itemValues.bulletPoint, "Pagebreak": _vm.itemValues.pageBreak
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.itemValues.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.itemValues.price))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.itemValues.time))]), _vm._v(" "), _c('ul', [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "Phase",
    class: {
      'Phase--optional': _vm.itemValues.optional, 'Phase--noTime': !_vm.itemValues.time
    }
  }, [_c('span', {
    staticClass: "Phase-Name"
  }, [_vm._v(_vm._s(_vm.itemValues.name))]), _vm._v(" "), _c('span', {
    staticClass: "Phase-Price"
  }, [_c('span', [_vm._v(_vm._s(_vm.itemValues['Price-Long']))]), _vm._v(" "), (_vm.itemValues.taxes !== undefined) ? _c('div', [_vm._v("zzgl. " + _vm._s(_vm.itemValues.taxes) + "% Ust.")]) : (_vm.itemValues['Taxes-19']) ? _c('div', [_vm._v("zzgl. 19% USt.")]) : _c('div', [_vm._v("zzgl. 7% USt.")])]), _vm._v(" "), (!!_vm.itemValues['time']) ? _c('span', {
    staticClass: "Phase-Time"
  }, [_vm._v(_vm._s(_vm.itemValues['Time-Long']))]) : _vm._e(), _vm._v(" "), _c('ul', [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Page not found")])
},staticRenderFns: []}

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, _vm._l((_vm.pages), function(page, i) {
    return _c('Page', {
      key: i,
      staticClass: "ProjectInfo"
    }, [(i === 0) ? _c('div', {}, [_c('img', {
      staticClass: "Logo",
      class: {
        'Logo--right': _vm.logoPosition === 'right'
      },
      attrs: {
        "src": _vm.logoSrc
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "ClientAddress"
    }, [_c('span', {
      staticClass: "CompanyAddress"
    }, [_vm._v(_vm._s(_vm.company && _vm.company.Name) + " " + _vm._s(_vm.company && _vm.company.Type) + " • " + _vm._s(_vm.company && _vm.company.Address && _vm.company.Address.Street) + " " + _vm._s(_vm.company && _vm.company.Address && _vm.company.Address.House) + " • " + _vm._s(_vm.company && _vm.company.Address && _vm.company.Address.PLZ) + " " + _vm._s(_vm.company && _vm.company.Address && _vm.company.Address.City))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.projectInfo['Client-Name']))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.projectInfo['Contact-Person']))]), _vm._v(" "), _vm._l((_vm.lines(_vm.projectInfo['Street'])), function(line, i) {
      return _c('span', {
        key: i
      }, [_vm._v(_vm._s(line))])
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.projectInfo['Place']))])], 2), _vm._v(" "), _c('div', {
      staticClass: "ProposalInfo"
    }, [_c('span', {
      staticClass: "ProposalInfo-Number"
    }, [_vm._v(_vm._s(_vm.projectInfo['Type']) + " Nr. " + _vm._s(_vm.projectInfo['Project-Number']))]), _vm._v(" "), _c('span', {
      staticClass: "ProposalInfo-Date"
    }, [_vm._v("vom " + _vm._s(_vm.projectInfo['Date']))])])]) : _vm._e(), _vm._v(" "), _c('article', {
      domProps: {
        "innerHTML": _vm._s(page.content)
      }
    }), _vm._v(" "), (i === 0) ? _c('CompanyAddress', {
      attrs: {
        "company": _vm.company
      }
    }) : _vm._e()], 1)
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {}, [_c('span', [_vm._v(_vm._s(_vm.itemValues.name))]), _vm._v(" "), _c('ul', [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Project-Price"
  }, [_c('div', {
    staticClass: "Project-Price-Subtotal"
  }, [_c('span', [_vm._v("Netto gesamt")]), _vm._v(" "), _c('span', {
    staticClass: "Project-Price-Subtotal-Price"
  }, [_vm._v("\n            " + _vm._s(_vm.milestones['Price-Netto']) + "\n        ")]), _vm._v(" "), (_vm.milestones['Time'] != 0) ? _c('span', {
    staticClass: "Project-Price-Subtotal-Time"
  }, [_vm._v("\n            " + _vm._s(_vm.milestones['Time-Long']) + "\n        ")]) : _vm._e()]), _vm._v(" "), _vm._l(({
    '5': _vm.milestones['Taxes-5-Long'],
    '7': _vm.milestones['Taxes-7-Long'],
    '16': _vm.milestones['Taxes-16-Long'],
    '19': _vm.milestones['Taxes-19-Long']
  }), function(taxes_value, taxes_key) {
    return _c('div', {
      staticClass: "Project-Price-Taxes",
      class: taxes_value == 0 || taxes_value === undefined ? 'is-empty' : ''
    }, [(taxes_value != 0 && taxes_value !== undefined) ? _c('span', [_vm._v("USt. " + _vm._s(taxes_key) + "% gesamt")]) : _vm._e(), _vm._v(" "), (taxes_value != 0 && taxes_value !== undefined) ? _c('span', {
      staticClass: "Project-Price--Subtotal-Price"
    }, [_vm._v("\n            " + _vm._s(taxes_value) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.milestones['Time'] != 0) ? _c('span', {
      staticClass: "Project-Price-Subtotal-Time"
    }) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "Project-Price-Total"
  }, [_c('span', [_vm._v("Brutto gesamt")]), _vm._v(" "), _c('span', {
    staticClass: "Project-Price-Subtotal-Price"
  }, [_vm._v("\n            " + _vm._s(_vm.milestones['Price-Brutto']) + "\n        ")]), _vm._v(" "), (_vm.milestones['Time'] != 0) ? _c('span', {
    staticClass: "Project-Price-Subtotal-Time"
  }) : _vm._e()])], 2)
},staticRenderFns: []}

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {}, [_c('span', [_vm._v(_vm._s(_vm.itemValues.name))])])
},staticRenderFns: []}

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Page', {
    staticClass: "ProjectConfirmation"
  }, [_c('img', {
    staticClass: "Logo",
    class: {
      'Logo--right': _vm.logoPosition === 'right'
    },
    attrs: {
      "src": _vm.logoSrc
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ProposalInfo"
  }, [_c('span', {
    staticClass: "Proposal-Info-Number"
  }, [_vm._v(_vm._s(_vm.projectType) + " Nr. " + _vm._s(_vm.projectNumber))]), _vm._v(" "), _c('span', {
    staticClass: "Proposal-Info-Date"
  }, [_vm._v("vom " + _vm._s(_vm.projectDate))])]), _vm._v(" "), _c('h2', {
    staticClass: "ProjectConfirmation-Title"
  }, [_vm._v("Rechnungslegung")]), _vm._v(" "), _c('article', {
    ref: "projectConfirmation"
  }), _vm._v(" "), _c('div', {
    staticClass: "Signature"
  }, [_vm._v("Datum, Unterschrift, Stempel")]), _vm._v(" "), _c('CompanyAddress', {
    attrs: {
      "company": _vm.company
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Wrapper Proposal"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isLoading) ? _c('Preloader') : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "Navigation"
  }, [_c('div', {
    staticClass: "Button-Third",
    on: {
      "click": _vm.backToBuilder
    }
  }, [_c('span', [_vm._v("Back to Builder")]), _vm._v(" "), _c('svg', {
    attrs: {
      "viewBox": "0 0 129 129"
    }
  }, [_c('path', {
    attrs: {
      "d": "m88.6,121.3c0.8,0.8 1.8,1.2 2.9,1.2s2.1-0.4 2.9-1.2c1.6-1.6 1.6-4.2 0-5.8l-51-51 51-51c1.6-1.6 1.6-4.2 0-5.8s-4.2-1.6-5.8,0l-54,53.9c-1.6,1.6-1.6,4.2 0,5.8l54,53.9z"
    }
  })])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "Button",
    on: {
      "click": _vm.printPage
    }
  }, [_c('span', [_vm._v("Print as PDF")])]), _vm._v(" "), _c('div', {
    staticClass: "Button",
    class: [{
        "Button--Blue": _vm.proposal["Status"] === "draft"
      },
      {
        "Button--Orange": _vm.proposal["Status"] === "pending"
      },
      {
        "Button--Green": _vm.proposal["Status"] === "accepted"
      },
      {
        "Button--Purple": _vm.proposal["Status"] === "updated"
      },
      {
        "Button--Red": _vm.proposal["Status"] === "rejected"
      }
    ],
    on: {
      "click": _vm.toggleButton
    }
  }, [(_vm.proposal["Status"] === "draft") ? _c('span', [_vm._v("draft")]) : _vm._e(), _vm._v(" "), (_vm.proposal["Status"] === "pending") ? _c('span', [_vm._v("pending")]) : _vm._e(), _vm._v(" "), (_vm.proposal["Status"] === "rejected") ? _c('span', [_vm._v("rejected")]) : _vm._e(), _vm._v(" "), (_vm.proposal["Status"] === "updated") ? _c('span', [_vm._v("updated")]) : _vm._e(), _vm._v(" "), (_vm.proposal["Status"] === "accepted") ? _c('span', [_vm._v("accepted")]) : _vm._e()])])]), _vm._v(" "), _c('CoverPage', {
    attrs: {
      "projectInfo": _vm.proposal,
      "company": _vm.resolvedCompany,
      "logoPosition": _vm.proposal['Logo-Position'] || 'left'
    }
  }), _vm._v(" "), _c('Milestones', {
    attrs: {
      "proposal": _vm.proposal
    }
  }), _vm._v(" "), _c('ConfirmationPage', {
    attrs: {
      "company": _vm.resolvedCompany,
      "logoPosition": _vm.proposal['Logo-Position'] || 'left',
      "projectConfirmation": _vm.proposal['Project-Confirmation'],
      "projectNumber": _vm.proposal['Project-Number'],
      "projectDate": _vm.proposal['Date'],
      "projectType": _vm.proposal['Type']
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Preloader"
  }, [_c('div', {
    staticClass: "sk-folding-cube"
  }, [_c('div', {
    staticClass: "sk-cube1 sk-cube"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube2 sk-cube"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube4 sk-cube"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube3 sk-cube"
  })])])
}]}

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.pages), function(page, i) {
    return _c('Page', {
      key: i,
      class: {
        'Page--continuing': i < _vm.pages.length - 1 && !page.table
      }
    }, [(i === 0) ? _c('div', {
      staticClass: "Proposal-Info"
    }, [_c('span', {
      staticClass: "Proposal-Info--Number"
    }, [_vm._v(_vm._s(_vm.proposal['Type']) + " Nr. " + _vm._s(_vm.proposal['Project-Number']))]), _vm._v(" "), _c('span', {
      staticClass: "Proposal-Info--Date"
    }, [_vm._v("vom " + _vm._s(_vm.proposal['Date']))])]) : _vm._e(), _vm._v(" "), (page.phases && page.phases.length) ? _c('div', {
      staticClass: "Milestones",
      class: {
        'Milestones--noTime': _vm.proposal.milestones['Time'] == 0
      }
    }, [(i === 0) ? _c('div', {
      staticClass: "Header"
    }, [_c('span', [_vm._v("Leistungen/ Phase")]), _vm._v(" "), _c('span', [_vm._v("Kosten")]), _vm._v(" "), (_vm.proposal.milestones && _vm.proposal.milestones['Time'] !== 0) ? _c('span', [_vm._v("Zeitraum")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('ul', {
      ref: "milestonesTree",
      refInFor: true,
      staticClass: "Milestones-Tree"
    }, _vm._l((page.phases), function(milestone, i) {
      return _c('Phase', {
        key: i,
        class: {
          'Phase--noName': milestone.fromPrev
        },
        attrs: {
          "itemValues": milestone.values,
          "milestones": _vm.proposal.milestones
        }
      }, _vm._l((milestone.children), function(firstLayer) {
        return _c('FirstLayer', {
          key: firstLayer.id,
          attrs: {
            "itemValues": firstLayer.values
          }
        }, _vm._l((firstLayer.children), function(secondLayer) {
          return _c('SecondLayer', {
            key: secondLayer.id,
            attrs: {
              "itemValues": secondLayer.values
            }
          }, _vm._l((secondLayer.children), function(thirdLayer) {
            return _c('ThirdLayer', {
              key: thirdLayer.id,
              attrs: {
                "itemValues": thirdLayer.values
              }
            })
          }), 1)
        }), 1)
      }), 1)
    }), 1)]) : _vm._e(), _vm._v(" "), (page.table && page.phases && page.phases.length) ? _c('PriceTable', {
      attrs: {
        "milestones": _vm.proposal.milestones
      }
    }) : _vm._e(), _vm._v(" "), (page.optionalPhases && page.optionalPhases.length) ? _c('div', {
      staticClass: "Milestones Milestones--optional",
      class: {
        'Milestones--noTime': !_vm.proposal.milestones['Time-Optional']
      }
    }, [(i === _vm.optionalPageNum) ? _c('div', {
      staticClass: "Proposal-Info"
    }, [_c('span', {
      staticClass: "Proposal-Info--Number"
    }, [_vm._v("Optionale Posten")])]) : _vm._e(), _vm._v(" "), _c('ul', {
      ref: "milestonesTree",
      refInFor: true,
      staticClass: "Milestones-Tree"
    }, _vm._l((page.optionalPhases), function(milestone, i) {
      return _c('Phase', {
        key: i,
        class: {
          'Phase--noName': milestone.fromPrev
        },
        attrs: {
          "itemValues": milestone.values,
          "milestones": _vm.proposal.milestones
        }
      }, _vm._l((milestone.children), function(firstLayer) {
        return _c('FirstLayer', {
          key: firstLayer.id,
          attrs: {
            "itemValues": firstLayer.values
          }
        }, _vm._l((firstLayer.children), function(secondLayer) {
          return _c('SecondLayer', {
            key: secondLayer.id,
            attrs: {
              "itemValues": secondLayer.values
            }
          }, _vm._l((secondLayer.children), function(thirdLayer) {
            return _c('ThirdLayer', {
              key: thirdLayer.id,
              attrs: {
                "itemValues": thirdLayer.values
              }
            })
          }), 1)
        }), 1)
      }), 1)
    }), 1)]) : _vm._e()], 1)
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Page"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ })
]),[86]);


// WEBPACK FOOTER //
// static/js/app.55059114168b605b7474.js